import PrimeButton from "../../../components/PrimeButton";

const FifthSection = () => {
  return (
    <div className="App relative h-[70%] my-20">
      <section className="m-auto md:px-0 px-10 md:w-[70%] w-full">
        <div className="flex flex-col md:flex-row gap-4 text-left justify-between">
          <div className="flex flex-col gap-4 md:w-1/2 w-full py-10">
            <h3 className="md:text-[32px] leading-[41px] text-xl font-bold">
              Exclusive Partnership <br />Driving Advanced Healthcare Solutions in Egypt
            </h3>
            <p className="md:text-[16px] leading-[29px] text-md font-light">
              H2A Medical Solutions, as the exclusive distributor of Philips ultrasound systems in Egypt, is dedicated to providing advanced and reliable healthcare solutions to customers.<br />
              H2A supports healthcare providers through exceptional diagnostic equipment, comprehensive education, and ongoing technical and post-sales services to improve patient care and outcomes.
            </p>
            <div className="w-full md:w-1/3 mt-3">
              <PrimeButton size="text-md" full={true} />
            </div>
          </div>
          <div className="relative hidden md:w-1/2 w-full md:flex justify-center items-center">
            <div className="w-full md:w-auto bg-gray-300 py-10 px-10 rounded-lg shadow-lg">
              <img
                className="w-full"
                src={require("../../../assets/device1.png")}
                alt="Medical Equipment"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FifthSection;
